// extracted by mini-css-extract-plugin
export var avatarContainer = "_k-0";
export var avatarTypingWave = "_k-i";
export var gray = "_k-f";
export var green = "_k-c";
export var icon = "_k-9";
export var image = "_k-1";
export var lg = "_k-6";
export var md = "_k-5";
export var presenceDot = "_k-b";
export var red = "_k-d";
export var sm = "_k-4";
export var status = "_k-a";
export var typingDot = "_k-h";
export var typingPill = "_k-g";
export var xl = "_k-7";
export var xs = "_k-3";
export var xxl = "_k-8";
export var xxs = "_k-2";
export var yellow = "_k-e";